export default {
      id: "parks-usage",
      viewBox: "0 0 16 19",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#parks",
      toString: function () {
        return this.url;
      }
    }